import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_friendships from '../../images/personality_types_details/diplomats_Campaigner_ENFP_friendships.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfp_friends = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress active">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Friendships</h1>


                        <p>As friends, Campaigners are cheerful and supportive, always sharing and developing ideas, and staying open-minded, taking in others’ thoughts and feelings. This warmth and sincerity makes people with the Campaigner personality type masters of drawing people out of their shells, and as a result they tend to have a huge circle of friends.</p>

                        <div class="description-pullout">As with other relationships, Campaigners view their friendships as opportunities to experience another angle of the universe, and tend to imbue potential friendships with that weighty and idealistic quality.</div>

                        <h2>An Exciting Adventure</h2>

                        <p>More outgoing types will naturally gravitate towards them, but Campaigners will also go to great lengths and be surprisingly persistent in their efforts to get to know more reserved personalities. Their ability to tune into others and speak their language with that characteristic infectious enthusiasm helps them in this endeavor, and the allure of mystery that reserved types, especially Introverted Intuitives, bring to the table will keep Campaigners intrigued for years. These personality types may never be able to reciprocate the breadth of human interest that Campaigners present, but they do appreciate Campaigners’ efforts.</p>

                        <p>But Campaigners’ interest in others can be a double-edged sword – this pure idealism comes with certain expectations, and too often Campaigners hold their friends in an unrealistic light, expecting them to keep up with the constant flow of ideas and experiences that they consider integral to life. Campaigners put their whole hearts into their friendships, and it can come as a shock for them to find that their friends aren’t the flawless Titans that they believed them to be. Whether it’s simple social fatigue or a focus on the physical and the practical instead of the mystical, people with the Campaigner personality type can find themselves disappointed by what they see as a lack of substance beneath the surface.</p>

                        <div class="scene">
                            <img alt="Campaigner friends" src={diplomats_Campaigner_ENFP_friendships} alt="Campaigner friends" />
                        </div>

                        <p>Campaigners tend to get deeply involved in others’ lives, going to great lengths and efforts to be the selfless, caring and supportive people they are, and all the while forget to take care of themselves. Both in terms of basic needs like financial stability and rest, as well as more emotional needs like mutual understanding and reciprocation, Campaigner personalities tend to give much more of themselves than most are even capable of giving back. This sort of imbalance isn’t sustainable, as (seemingly) one-sided generosity often leads to criticism and resentment on both sides.</p>

                        <h2>Making Life Spectacular</h2>

                        <p>Luckily, Campaigners are open-minded and sincere enough in their friendships, and connect with and understand even their acquaintances well enough, that they recognize that not everyone expresses themselves in the same ways, and that that’s okay. Their sensitivity may make it too challenging to play with more critical and argumentative personalities, such as strongly expressed Thinking (T) and Judging (J) types, but they do appreciate, even cherish, the company of most anyone who appreciates theirs, and the adventures and experiences they have together are the stuff a good life is made of.</p>

                        <div class="number">04</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfp-relationships-dating' className='next-feature'>
                            Romantic Relationships
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfp-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout >
    )
}

export default enfp_friends
